import { Component, input } from '@angular/core';

@Component({
  selector: 'sbnb-form-label',
  standalone: true,
  imports: [],
  template: `
    <label class="text-xs block text-grape-darker strong">
      {{ label() }}

      @if (required()) {
        <span class="text-xs text-grape-darker">*</span>
      }
    </label>
  `,
})
export class FormLabelComponent {
  label = input.required<string>();
  required = input<boolean>(false);
}
